  export const ErrorMessageConst = {
    ExpiredSession: 'Sesión expirada',
    ErrorDeletingItem: "No se pudo eliminar el servicio del carrito",
    OperationFailed: "No se pudo completar la operación",

    BadRqequest: 'No se pudo procesar la información, favor de revisar con el Administrador.',

    InvalidDomainCharacters: 'Los caracteres válidos son números, letras del alfabeto inglés y el guión (-). No deben llevar guión al comienzo ni al final del nombre, ni dos guiones seguidos. La longitud del nombre no debe exceder de 63 caracteres.',
    InvalidTLD: 'TLD no válido, con Akky puedes registrar los siguientes TLDs: .MX y sus distintas clasificaciones, .COM, .NET, .CC, .TV, .LAT, .AUTOS, .LOL, .MOM y .XYZ.',
    DomainMaintenance: 'Registro no disponible temporalmente.',
    PartialError: 'Algunos dominios no se agregaron.',
    LinkStudentDuplicated: 'El link de tu página ya ha sido registrado.',
    EmailStudentDuplicated: 'Tu Email institucional ya ha sido registrado.',
    EmailProjectStudentDuplicated: 'El Email de tu proyecto ya ha sido registrado.',

    RegistrantRequired: "Por favor, confirma que los datos del Registrante (Titular) y Contactos son correctos y completos.",
    MoralRegistratRequired: "Es necesario que el Registrante (Titular) de los dominios .EDU.MX, .GOB.MX Y .NET.MX sea persona moral.",
    CCTRequired: "El CCT es requerido para la solicitud de registro de un dominio .EDU.MX",
    RegitrationTermsCheck: "Debes marcar que entiendes la importancia de los datos del registrante (Titular) y Contactos.",
    CreateContactFailed: "Ocurrió un error al agregar un contacto",
    UpdateContactFailed: "Ocurrió un error al editar un contacto",

    CouponStudentDuplicated: 'La Matrícula ya ha sido registrada.',

    ChatUnavailable: "Chat temporalmente no disponible",

    CaptchaNeededToContinue: "Por favor, complete el CAPTCHA para continuar.",

    TokenInvalid: "Código invalido favor de capturar el código correcto.",
    TokenOnlyNumbers: "El código de verificación debe ser numérico.",
    TokenRequired: "Favor de capturar el código de verificación.",
    TokenLength: "Verifica el número de dígitos del código ingresado.",

    BackupCodeRequired: "Favor de capturar el código de respaldo.",
    BackupCodeLength: "Verifica el número de dígitos del código ingresado.",

    //Error de formularios
    FormRequired: 'Campo requerido',
    FormPattern: 'Por favor, ingresa un texto válido',
    FormInvalid: 'El dato ingresado es inválido',
    FormMaxLength: 'Longitud máxima de @1 caracteres',
    FormMinLength: 'Longitud mínima de @1 caracteres',
    FormEmail: 'Formato de correo electrónico inválido',
    FormMatching: 'El email no coincide'
};
